/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, extendObservable, observable } from 'mobx';
import { createBaseStoreHouse } from 'src/luis/core/stores/baseStoreHouse';
import { BaseStoreHouse } from 'src/luis/types/stores/core/BaseStoreHouse';
import { PredictionStoreHouse } from 'src/luis/types/stores/utterances/PredictionStoreHouse';
import { SubtractStore } from 'src/luis/types/SubtractStore';

export const createPredictionStoreHouse = (): PredictionStoreHouse => {
    const baseStore = createBaseStoreHouse();

    const predictionStoreHouse: SubtractStore<PredictionStoreHouse, BaseStoreHouse> = {
        predictions: new Map(),

        /**
         * Adds a batch of predictions to the predictions property.
         */
        addPredictions(predictionStores) {
            predictionStores.forEach(val => this.predictions.set(val.text, val));
        },

        /**
         * Adds a prediction to the predictions property.
         */
        addPrediction(predictionStore) {
            this.predictions.set(predictionStore.text, predictionStore);
        },

        /**
         * Mark all predictions as dirty.
         */
        invalidatePredictions() {
            this.predictions.forEach(p => p.setIsDirty(true));
        }
    };

    return extendObservable(
        baseStore,
        predictionStoreHouse,
        {
            predictions: observable,
            addPredictions: action,
            addPrediction: action,
            invalidatePredictions: action
        },
        { deep: false }
    );
};
